import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CalculationModelNames, CalculationModelType } from 'src/app/contracts';
import { CalculationService } from 'src/app/services';

@Component({
    selector: 'app-select-model',
    templateUrl: './select-model.component.html',
    styleUrls: ['./select-model.component.css']
})
export class SelectModelComponent implements OnInit {
    public calculationModelType = CalculationModelType;
    public calculationModelNames = CalculationModelNames;

    constructor(private readonly router: Router, private readonly calculationService: CalculationService) { }

    public ngOnInit(): void {
    }

    public selectModel(model: CalculationModelType): void {
        this.calculationService.setTempCalculationModel(model);
        this.router.navigate(['riskassessment/select-parameters']);
    }
}
